import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CarMaxLogo from '@shared/components/CarMaxLogo';
import useWindowSize from '@shared/hooks/useWindowSize';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import EarlyExitDialog from './EarlyExitDialog';
import styles from './MinimizedHeader.module.scss';

interface Props {
    buttonText?: string;
    buttonLink?: string;
    exitDialogText?: JSX.Element;
    isError?: boolean;
}

export default function MinimizedHeader({ buttonText, buttonLink, isError }: Props) {
    const navigate = useNavigate();

    window.addEventListener('popstate', () => isError && navigate(0));

    const { windowWidth } = useWindowSize();
    const getLogoType = (windowWidth: number) => {
        if (windowWidth < 600) {
            return 'mini-icon-only';
        } else {
            return 'small';
        }
    };

    const [isOpen, setIsOpen] = useState(false);

    const openModal = (event: Event) => {
        event.preventDefault();
        setIsOpen(true);
    };

    const handleOnClick = () => {
        navigate(buttonLink);
        isError && navigate(0);
    };

    const toggleDialog = () => setIsOpen(!isOpen);
    return (
        <>
            <Box className={styles['minimized-header']} data-testid="minimized-header">
                <Container className={styles['minimized-header-container']}>
                    <Button
                        onClick={handleOnClick}
                        size="small"
                        variant="text"
                        className={styles['button']}
                        style={{ marginTop: '4px' }}
                        data-testid="arrow-back-button"
                        startIcon={<ArrowBackIcon style={{ marginBottom: '2px' }} />}>
                        {buttonText ? buttonText : 'Exit'}
                    </Button>
                    <CarMaxLogo
                        logoType={getLogoType(windowWidth)}
                        lightTheme={true}
                        className={styles['logo']}
                        onClick={e => openModal(e)}
                    />

                    <hzn-inline
                        space="none"
                        align-x="end"
                        style={{ paddingRight: '2rem', width: 'fit-content' }}
                        class={styles['lock-logo']}>
                        <LockOutlinedIcon style={{ height: '16px', width: '16px' }} />
                        <hzn-text tone="subdued" inline style={{ marginLeft: '0.5rem' }}>
                            SECURE
                        </hzn-text>
                    </hzn-inline>
                </Container>
            </Box>
            <EarlyExitDialog onClose={toggleDialog} open={isOpen} />
        </>
    );
}
